import AccessTimeIcon from "@mui/icons-material/AccessTime";

import { DailyTask } from "../util/tasks";

interface taskListProps {
  key: number;
  task: DailyTask;
}

export default function TaskListItem(props: taskListProps) {
  return (
    <li>
      <div className="task-content">{props.task.name}</div>
      <div className="task-duration">
        <input
          placeholder="30"
          defaultValue={props.task.duration}
          maxLength={3}
          onClick={(e) => {
            const input = e.target as HTMLInputElement;
            if (!input) return;
            input.focus();
            input.select();
          }}
        />
        <AccessTimeIcon />
      </div>
    </li>
  );
}
